import React from 'react';

import { Glossary, BoardGL } from 'common/utils/glossary';
import { Column, Separator } from 'common/components';
import { LanguageButton, CountryButton } from 'common/containers';

interface MenuBoardProps {
  /** MenuBoardの表示有無 */
  isDisplay: boolean;
  /** ログイン済みか否か */
  isLoggedIn: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** プラン一覧の押下処理 */
  onClickPlanList: () => void;
  /** プランの管理の押下処理 */
  onClickContractedList: () => void;
  /** 購入履歴の押下処理 */
  onClickPurchaseHistory: () => void;
  /** Newsの押下処理 */
  onClickNews: () => void;
  /** 利用ガイドの押下処理 */
  onClickGuide: () => void;
  /** FAQの押下処理 */
  onClickFaq: () => void;
  /** お問い合わせの押下処理 */
  onClickContact: () => void;
  /** 利用規約の押下処理 */
  onClickTermsOfService: () => void;
  /** プライバシーポリシーの押下処理 */
  onClickPrivacyPolicy: () => void;
  /** クッキーポリシーの押下処理 */
  onClickCookiePolicy: () => void;
  /** サードパーティ製ソフトウェアについての押下処理 */
  onClickSoftware: () => void;
}

/**
 * プルダウンメニューのPresentation Component
 */
export const MenuBoard: React.FC<MenuBoardProps> = ({
  isDisplay,
  isLoggedIn,
  glossary,
  onClickPlanList,
  onClickContractedList,
  onClickPurchaseHistory,
  onClickNews,
  onClickGuide,
  onClickFaq,
  onClickContact,
  onClickTermsOfService,
  onClickPrivacyPolicy,
  onClickCookiePolicy,
  onClickSoftware
}) => {
  const _component = (
    <div className="menuBoard">
      {!isLoggedIn ? (
        <>
          <CountryButton type="column" data-test="menuBoardCountry" />
          <LanguageButton type="column" data-test="menuBoardLanguage" />
          <Separator type="separator" data-test="menuBoardSeparator1" />{' '}
        </>
      ) : null}

      <Column
        type="item"
        data-test="menuPlanListMenu"
        onClick={onClickPlanList}
      >
        {glossary.glx(BoardGL.PlanListMenu)}
      </Column>
      <Column
        type="item"
        data-test="menuContractListMenu"
        onClick={onClickContractedList}
      >
        {glossary.glx(BoardGL.ContractListMenu)}
      </Column>
      <Column
        type="item"
        data-test="menuPurchaseHistoryMenu"
        onClick={onClickPurchaseHistory}
      >
        {glossary.glx(BoardGL.PurchaseHistory)}
      </Column>

      <Separator type="separator" data-test="menuBoardSeparator2" />

      <Column type="item" data-test="menuNews" onClick={onClickNews}>
        {glossary.glx(BoardGL.News)}
      </Column>
      <Column type="item" data-test="menuGuideMenu" onClick={onClickGuide}>
        {glossary.glx(BoardGL.GuideMenu)}
      </Column>
      <Column type="item" data-test="menuFaq" onClick={onClickFaq}>
        {glossary.glx(BoardGL.Faq)}
      </Column>
      <Column type="item" data-test="menuContactUs" onClick={onClickContact}>
        {glossary.glx(BoardGL.ContactUs)}
      </Column>
      <Column
        type="item"
        data-test="menuTermsOfService"
        onClick={onClickTermsOfService}
      >
        {glossary.glx(BoardGL.TermsOfService)}
      </Column>
      <Column
        type="item"
        data-test="menuPrivacyPolicy"
        onClick={onClickPrivacyPolicy}
      >
        {glossary.glx(BoardGL.PrivacyPolicy)}
      </Column>
      <Column
        type="item"
        data-test="menuCookiePolicy"
        onClick={onClickCookiePolicy}
      >
        {glossary.glx(BoardGL.CookiePolicy)}
      </Column>
      <Column type="item" data-test="menuSoftware" onClick={onClickSoftware}>
        {glossary.glx(BoardGL.AboutSoftware)}
      </Column>
    </div>
  );
  return isDisplay ? _component : null;
};
